<template>
    <sui-list bulleted class="mini preformated-input-list">
        <sui-list-item v-if="!hasMetadatas()" class="no-bullet">{{ $t('gateway.metadatas.noFound') }}</sui-list-item>
        <sui-list-item v-else class="no-bullet">{{ $t('gateway.metadatas.detected') }}:</sui-list-item>

        <sui-list-item v-for="m in assignedMetadatas" :key="m.id"  style="margin-top: 5px">
            <code>{{ m.label }}</code>
        </sui-list-item>
    </sui-list>
</template>

<script>
    import store from '@/store';
import { mapGetters } from 'vuex';

    export default {
        name: 'MetadataInputList',
        props: {
            value: String,
        },
        methods: {
            hasMetadatas() {
                return this.assignedMetadatas.length > 0;
            },
        },
        computed: {
            ...mapGetters(['activeGateway']),
            state: {
                get() { return store.state; }
            },
            assignedMetadatas: {
                get() {
                    if (!this.value) {
                        return [];
                    }

                    return this.state.metadatas.filter(m => this.value.includes(m.code));
                },
            }
        },
    }
</script>
